import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=28319594&"
import script from "./CompanyList.vue?vue&type=script&lang=js&"
export * from "./CompanyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28319594')) {
      api.createRecord('28319594', component.options)
    } else {
      api.reload('28319594', component.options)
    }
    module.hot.accept("./CompanyList.vue?vue&type=template&id=28319594&", function () {
      api.rerender('28319594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/company/CompanyList.vue"
export default component.exports